/***** Begin Global Scripts *****/

/* A fix for the iOS orientationchange zoom bug. Script by @scottjehl, rebound by @wilto.MIT / GPLv2 License.*/
(function(a) { function m() { d.setAttribute("content", g), h = !0 } function n() { d.setAttribute("content", f), h = !1 } function o(b) { l = b.accelerationIncludingGravity, i = Math.abs(l.x), j = Math.abs(l.y), k = Math.abs(l.z), (!a.orientation || a.orientation === 180) && (i > 7 || (k > 6 && j < 8 || k < 8 && j > 6) && i > 5) ? h && n() : h || m() } var b = navigator.userAgent; if (!(/iPhone|iPad|iPod/.test(navigator.platform) && /OS [1-5]_[0-9_]* like Mac OS X/i.test(b) && b.indexOf("AppleWebKit") > -1)) return; var c = a.document; if (!c.querySelector) return; var d = c.querySelector("meta[name=viewport]"), e = d && d.getAttribute("content"), f = e + ",maximum-scale=1", g = e + ",maximum-scale=10", h = !0, i, j, k, l; if (!d) return; a.addEventListener("orientationchange", m, !1), a.addEventListener("devicemotion", o, !1) })(this);

/* Fix older IE console.log to prevent errors */
if (!window.console)
{
  (function()
  {
    var names = ["log", "info", "warn", "error", "assert", "dir", "dirxml", "group", "groupEnd", "time", "timeEnd", "count", "trace", "profile", "profileEnd"];

    window.console = {};

    for (var i = 0; i < names.length; i++)
    {
      window.console[names[i]] = function() { };
    }
  } ());
};

callbackEvents = {};

jQuery.CallbackEvents = function (id)
{
  var callbacks, method,
    topic = id && callbackEvents[id];

  if (!topic)
  {
    callbacks = jQuery.Callbacks();
    topic = {
      publish: callbacks.fire,
      subscribe: callbacks.add,
      unsubscribe: callbacks.remove
    };
    if (id)
    {
      callbackEvents[id] = topic;
    }
  }
  return topic;
};

var Global = {};

Global.headerRow = '#headerRow';
Global.headerArea = '#headerArea';
Global.bannerRow = '#bannerRow';
Global.bodyRow = '#bodyRow';
Global.bannerContainer = '#bannerContainer';
Global.bodyContainer = '#bodyContainer';
Global.bodyArea = '#bodyArea';
Global.footerRow = '#footerRow';
Global.leftRailArea = '#leftRailArea';
Global.rightRailArea = '#rightRailArea';
Global.drawerIdentifier = '#DrawerContainer';
Global.drawerTabIdentifier = '#DrawerTab';
Global.leftBodyColumn = '#leftBodySplitColumn';
Global.rightBodyColumn = '#rightBodySplitColumn';
Global.tophatArea = '#TopHatContainer';
Global.globalNavigationArea = '.GlobalNavigation';
Global.wrapExpanded = '.wrapExpanded';
Global.bannerIdentifier = '';
Global.bodyIdentifier = '';
Global.pageStateCookie = 'PageStateComponent';
Global.scrollLeftRail = true;
Global.urlMyAccount = '';
Global.urlMyAccountLogin = '';
Global.urlMyAccountLoginError = '';
Global.urlMyAccountLogout = '';
Global.zipCodeProgressOverlay = '#progressOverlay';
Global.zipCodeOverlayIdentifier = '';
Global.zipCodeOverlayDelayIdentifier = '';
Global.zipCodeOverlayQuoteProductIdentifier = '';
Global.zipCodeOverlayQuoteCampaignIdentifier = '';
Global.zipCodeOverlayQuoteMobileIdentifier = '';
Global.zipCodeOverlayLatitudeIdentifier = '';
Global.zipCodeOverlayLongitudeIdentifier = '';
Global.zipCodeOverlaySaveErrorIdentifier = '';
Global.zipCodeOverlaySaveButtonIdentifier = '';
Global.zipCodeOverlayGeoLocationErrorIdentifier = '';
Global.zipCodeOverlayGeoLocationButtonIdentifier = '';
Global.zipCodeOverlayZipBoxIdentifier = '';
Global.zipCodeOverlayZipCode = '';
Global.zipCodeProgressOverlayTimeout = '';
Global.defaultDocumentHeight = 0;
Global.defaultHeaderHeight = 0;
Global.headerHeight = 0;
Global.footerHeight = 0;
Global.footerTrigger = 0;
Global.drawerTabHeight = 0;
Global.drawerClosedHeight = 8;
Global.drawerTabArrow = '.drawerArrow, .drawerArrow-es';
Global.isDrawerSticky = true;
Global.drawerNumberAgents = 0;
Global.drawerAgentWebsiteLink = '';
Global.loadComplete = false;
Global.isTopNavigationExpanded = false;
Global.isTopHatExpanded = false;
Global.isDrawerExpanded = false;
Global.isContentShort = false;
Global.isWideMobileWindow = false;
Global.isNarrowWindow = false;
Global.isTabletWindow = false;
Global.isMobileWindow = false;
Global.wideWindow = false;
Global.shortWindow = false;
Global.expandedWidthPage = false;
Global.isPortrait = false;
Global.isLandscape = false;
Global.isIE11 = false;
Global.isIE10 = false;
Global.isIE9 = false;
Global.isIE8 = false;
Global.isIE7 = false;
Global.isChrome = false;
Global.isSafari = false;
Global.isFF = false;
Global.isTablet = false;
Global.isKindle = false;
Global.isPlayBook = false;
Global.widthMobile = 767;
Global.widthTablet = 992;
Global.boundResizeFunctions = [];
Global.agentReviewsRequested = [];
Global.myAgents = '';
Global.HasAgentsLoaded = false;
Global.HasBillingLoaded = false;
Global.IsLocalStorageAvailable = false;
Global.quoteCTANumberAgents = 0;
Global.anyNumberAgents = 0;
Global.afoNumberAgents = 0;
Global.userZipCode = '';
Global.isInitialLoadClick = true;
Global.SCPageName = "/home/home.aspx";
Global.More = "More";
Global.Less = "Less";

Global.emailAgentIconText = "Email agent";
Global.visitAgentIconText = "View Website";
Global.getDirectionsLinkText = "Get Directions";
Global.callAgentLinkText = "Call agent";
Global.agentReviewLinkText = "Review";
Global.isEspanol = false;

// This function restricts characters in a text box to either letters only or letters and numbers.
Global.RestrictCharactersText = function(allowNumbers, e)
{
  var text;

  if ((e.keyCode == 8) || (e.keyCode == 9))
  {
    return true;
  }
  if (e.keyCode != 0)
  {
    text = e.keyCode;
  }
  else if (e.charCode != 0)
  {
    text = e.charCode;
  }

  if ((text == 8) || ((text >= 33) && (text <= 44)))
  {
    return false;
  }

  if (allowNumbers)
  {
    return /^[a-zA-Z0-9 -.]$/.test(String.fromCharCode(text));
  }
  else
  {
    return /^[a-zA-Z -.]$/.test(String.fromCharCode(text));
  }
}

// This function restricts characters in a text box to either numbers only.
Global.RestrictCharactersNumbers = function(e)
{
  var text;

  if ((e.keyCode == 8) || (e.keyCode == 9) || (e.keyCode == 37) || (e.keyCode == 39) || (e.keyCode == 46))
  {
    return true;
  }
  if (e.keyCode != 0)
  {
    text = e.keyCode;
  }
  else if (e.charCode != 0)
  {
    text = e.charCode;
  }

  if ((text == 8) || ((text >= 35) && (text <= 40)) || (text == 46))
  {
    return false;
  }

  return /^[0-9]$/.test(String.fromCharCode(text));
}

Global.RestrictInputLength = function(object)
{
  if (object.value.length > object.maxLength)
  {
    object.value = object.value.slice(0, object.maxLength)
  }
}




// Bind to the resize event to support Top Navigation, Left Rail functionality.
Global.BindResize = function () {
    var wait = setInterval(function () {
        if (!$(Global.bannerIdentifier).is(":animated") && !$(Global.bodyIdentifier).is(":animated")) {
            clearInterval(wait);

            //Current window height and width
            var lastWindowHeight = $(window).height();
            var lastWindowWidth = $(window).width();

            $(window).resize(function () {
                //Confirm window was actually resized (IE)
                if (($(window).height() != lastWindowHeight) || ($(window).width() != lastWindowWidth)) {
                    //Set this windows size
                    lastWindowHeight = $(window).height();
                    lastWindowWidth = $(window).width();

                    if (Global.loadComplete) {
                        Global.CheckWindowWidth();
                        Global.SetContentPadding(false);

                        Global.CollapseTopNavigation();
                        Global.CollapseTopHat();

                        //Global.ScrollLeftRail();
                        Global.ScrollBackToTop();

                        Global.SetFooterPosition();

                        Global.SetResponsiveStyles();

                        Global.SwapHomePageDivs();

                        Global.RerunResizeFunctions();
                    }
                }
            });
        }
    }, 200);
}


// This function sets global variables related to the device's display properties.
Global.SetWindowProperties = function()
{
  if (($(Global.bannerRow).length > 0) && ($(Global.bannerContainer).length <= 0))
  {
    Global.bannerIdentifier = Global.bannerRow;
  }
  else
  {
    Global.bannerIdentifier = Global.bannerContainer;
  }

  if (($(Global.bodyRow).length > 0) && ($(Global.bodyContainer).length <= 0))
  {
    Global.bodyIdentifier = Global.bodyRow;
  }
  else
  {
    Global.bodyIdentifier = Global.bodyContainer;
  }


  var winWidth = Global.ViewportWidth();
  var winHeight = Global.ViewportHeight();

  if (winWidth >= 1280)
  {
    wideWindow = true;
  }
  else if ((winWidth > Global.widthMobile) && (winWidth < 992))
  {
    Global.isWideMobileWindow = true;
  }
  else if ((winWidth > Global.widthMobile) && (winWidth < 960))
  {
    Global.isWideMobileWindow = true;
    Global.isNarrowWindow = true;
  }
  else if (winWidth <= Global.widthMobile)
  {
    Global.isWideMobileWindow = true;
    Global.isNarrowWindow = true;
    Global.isMobileWindow = true;
  }

  if (winHeight <= 500)
  {
    shortWindow = true;
  }

  if (typeof window.onorientationchange !== 'undefined')
  {
    switch (orientation)
    {
      case 0:
      case 180:
        Global.isPortrait = true;
        Global.isLandscape = false;
        break;
      case 90:
      case -90:
        Global.isPortrait = false;
        Global.isLandscape = true;
        break;
      default:
        /* Do Nothing */
        break;
    }

    /* Silly Android Honeycomb and BlackBerry Playbook have landscape and portrait backwards... */
    var ua = navigator.userAgent.toLowerCase();

    if (ua.indexOf('android 3') > -1 || ua.indexOf('playbook') > -1)
    {
      switch (orientation)
      {
        case 0:
        case 180:
          Global.isPortrait = false;
          Global.isLandscape = true;
          break;
        case 90:
        case -90:
          Global.isPortrait = true;
          Global.isLandscape = false;

          break;
        default:
          /* Do Nothing */
          break;
      }
    }
  }

  if ($(Global.wrapExpanded).length > 0)
  {
    Global.expandedWidthPage = true;
  }

  Global.BindResize();
}

Global.ViewportWidth = function()
{
  if (!('innerWidth' in window))
  {
    var e = document.documentElement || document.body;
    return e['clientWidth'];
  }
  else
  {
    return window['innerWidth'];
  }
}

Global.ViewportHeight = function()
{
  if (!('innerHeight' in window))
  {
    var e = document.documentElement || document.body;
    return e['clientHeight'];
  }
  else
  {
    return window['innerHeight'];
  }
}

// This function sets global variables related to the user's browser properties.
Global.DetectBrowser = function()
{
  /* used for minor display diffrences such as font rendering widths */
  if (navigator.userAgent.match(/MSIE\s([\d.]+)/) != null)
  {
    Global.isIE10 = true;
    //$('body').addClass('ie10');
  }

  if (navigator.userAgent.match(/Android/) || navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/Silk/) || navigator.userAgent.match(/PlayBook/))
  {
    Global.isTablet = true;
    //$('body').addClass('tablet');

    if (navigator.userAgent.match(/Silk/))
    {
      /* Silk is Kindle Fire Browser */
      //$('body').addClass('silk');
      Global.isKindle = true;
    }

    if (navigator.userAgent.match(/PlayBook/))
    {
      /* Silk is Kindle Fire Browser */
      //$('body').addClass('bb');
      Global.isPlayBook = true;
    }
  }
  else
  {
    /* Site should only show up for Tablets. */
  }

  if (navigator.userAgent.match(/Safari/))
  {
    if (navigator.userAgent.match(/Chrome/))
    {
      //$('body').addClass('safari chrome');
      Global.isSafari = true;
      Global.isChrome = true;
    }
    //else if (navigator.userAgent.match(/iPad/))
    //{
    //  //$('body').addClass('safari ios ipad');
    //  Global.isSafari = true;
    //}
    else
    {
      //$('body').addClass('safari');
      Global.isSafari = true;
    }
  }
  else if (navigator.userAgent.match(/Firefox/))
  {
    //$('body').addClass('firefox');
    Global.isFF = true;
  }

  isIE9 = $("div").hasClass("ie9") ? true : false;
  isIE8 = $("div").hasClass("ie8") ? true : false;
  isIE7 = $("div").hasClass("ie7") ? true : false;
  //isChrome = $("body").hasClass("chrome") ? true : false;
  //isSafari = $("body").hasClass("safari") ? true : false;
  //isFF = $("body").hasClass("firefox") ? true : false;
  //isKindle = $("body").hasClass("silk") ? true : false;
  //isPlayBook = $("body").hasClass("bb") ? true : false;
}

// This function sets global variables related to the height of the header.
Global.SetHeaderHeightValues = function()
{
  $($(Global.headerRow).find('.iw_component').get()).each(function()
  {
    var el = $(this).children('div').children('div');
    Global.headerHeight = Global.headerHeight + el.height();
  });

  if (Global.headerHeight < $(Global.headerRow).height())
  {
    Global.headerHeight = $(Global.headerRow).height();
  }

  if ($(Global.headerArea).height() > Global.headerHeight)
  {
    Global.headerHeight = $(Global.headerArea).height();
  }

  Global.defaultHeaderHeight = Global.headerHeight;
  $(Global.headerRow).css('height', Global.headerHeight + 'px');
}

// This function adds padding to the banner or body areas to position them below the header row.
Global.SetContentPadding = function(animate)
{
  if (!Global.expandedWidthPage)
  {
    if (!Global.isMobileWindow)
    {
      if (animate)
      {
        if ($(Global.bannerIdentifier).length > 0)
        {
          $(Global.bannerIdentifier).animate({ 'padding-top': $(Global.headerRow).height() });
        }
        else
        {
          $(Global.bodyIdentifier).animate({ 'padding-top': ($(Global.headerRow).height() + 10) });
        }

        if ($(Global.rightRailArea).length > 0)
        {
          $(Global.rightRailArea).animate({ 'padding-top': $(Global.headerRow).height() });
        }
      }
      else
      {
        if ($(Global.bannerIdentifier).length > 0)
        {
          $(Global.bannerIdentifier).css('padding-top', $(Global.headerRow).height());
        }
        else
        {
          $(Global.bodyIdentifier).css('padding-top', ($(Global.headerRow).height() + 10));
        }

        if (($(Global.rightRailArea).length > 0) && ($(Global.rightRailArea).offset().top <= 0))
        {
          $(Global.rightRailArea).css('padding-top', $(Global.headerRow).height());
        }
      }
    }
    else
    {
      if ($(Global.bannerIdentifier).length > 0)
      {
        $(Global.bannerIdentifier).css('padding-top', '');
      }
      else
      {
        $(Global.bodyIdentifier).css('padding-top', '');
      }
    }
  }
}

// This function determines if the height of the left rail will allow it to scroll with the page.
Global.SetLeftRailScrolling = function()
{
  if (Global.isMobileWindow || (($(Global.leftRailArea).length > 0) && ((Global.headerHeight + $(Global.leftRailArea).offset().top + $(Global.leftRailArea).height()) >= $(Global.footerRow).offset().top)))
  {
    Global.scrollLeftRail = false;
  }
}

// This function adds events to be bound during a resize.
Global.AddResizeEvent = function(func)
{
  if (typeof func !== 'function')
  {
    return false
  }

  for (i = 0, j = Global.boundResizeFunctions.length; i < j; i++)
  {
    if (Global.boundResizeFunctions[i].toString() == func.toString())
    {
      return false;
    }
  }

  Global.boundResizeFunctions[Global.boundResizeFunctions.length] = func;
}

// This function rebinds events to the window.resize event.
Global.RerunResizeFunctions = function ()
{
  for (i = 0, j = Global.boundResizeFunctions.length; i < j; i++)
  {
    // check if component / objest contains initiate method
    if (typeof Global.boundResizeFunctions[i] === 'function')
    {
      Global.boundResizeFunctions[i]();
    }
  }
}









Global.CheckWindowWidth = function()
{
  if (Global.ViewportWidth() <= Global.widthMobile)
  {
    Global.isMobileWindow = true;
  }
  else
  {
    Global.isMobileWindow = false;
  }

  if (Global.ViewportWidth() < 992)
  {
    Global.isWideMobileWindow = true;
  }
  else
  {
    Global.isWideMobileWindow = false;
  }
}

Global.SetFooterPosition = function()
{
  if (!Global.expandedWidthPage)
  {
    if ((Global.isDrawerSticky == true) && (Global.isMobileWindow == false))
    {
      $(Global.footerRow).css('width', '');
      $(Global.footerRow).css('left', '');
      $(Global.footerRow).css('margin-top', '');

      $(Global.bodyIdentifier).css('padding-bottom', Global.footerHeight + 'px');
      $(Global.footerRow).css('height', Global.footerHeight + 'px');

      if ($(Global.footerRow).css('position') != 'absolute')
      {
        if ($.isFunction($(Global.footerRow).has) && ($(Global.footerRow).has(Global.drawerIdentifier).length > 0))
        {
          $(Global.footerRow).css('position', 'fixed');
          $(Global.footerRow).css('top', ($(window).height() + Global.footerHeight - Global.drawerClosedHeight) + 'px');
        }
        else
        {
          var componentHeights = 0;

          $(Global.footerRow).css('position', 'absolute');
          //$(Global.footerRow).css('bottom', '0');
          $($(Global.footerRow).find('.iw_component').get()).each(function ()
          {
            var el = $(this).children('div').children('div');
            $(el).css('top', componentHeights + 'px');
            componentHeights = componentHeights + el.height();
          });
        }
      }
    }
    else if ((Global.isDrawerSticky != true) && (Global.isMobileWindow != true))
    {
      var windowWidth = $(window).width();

      //if ($(Global.footerRow).css('position') != 'absolute')
      //{
      //  $(Global.bodyIdentifier).css('padding-bottom', '');
      //}
      //else
      //{
      //  $(Global.bodyIdentifier).css('padding-bottom', Global.footerHeight + 'px');
      //}

      if ($(Global.footerRow).css('position') == 'fixed')
      {
        $(Global.footerRow).css('position', '');
        $(Global.bodyIdentifier).css('padding-bottom', Global.footerHeight + 'px');
      }
      else if ($(Global.footerRow).css('position') == 'absolute')
      {
        $(Global.footerRow).css('position', '');
        $(Global.bodyIdentifier).css('padding-bottom', '');
      }
      else
      {
        $(Global.bodyIdentifier).css('padding-bottom', Global.footerHeight + 'px');
        //$(Global.bodyIdentifier).css('padding-bottom', '');
      }

      $(Global.footerRow).css('top', '');
      $(Global.footerRow).css('height', '');
      $(Global.footerRow).css('margin-top', Global.drawerTabHeight + 'px');

      if (windowWidth <= $(Global.bodyIdentifier).width())
      {
        $(Global.footerRow).css('width', $(Global.bodyIdentifier).width() + 'px');
        $(Global.footerRow).css('left', '0px');
      }
      else
      {
        $(Global.footerRow).css('width', windowWidth + 'px');
        $(Global.footerRow).css('left', '');
        try
        {
          $(Global.footerRow).css('left', windowWidth - ($(Global.footerRow).offset().left + $(Global.footerRow).width()) + 'px');
        } catch (ex)
        {
        }
      }
    }
    else if (Global.isMobileWindow)
    {
      $(Global.bodyIdentifier).css('padding-bottom', '');
      $(Global.footerRow).removeAttr('style');

      $($(Global.footerRow).find('.iw_component').get()).each(function ()
      {
        var el = $(this).children('div').children('div');
        $(el).css('top', '');
      });
    }
  }
}

Global.PositionFooterComponents = function()
{
  if (!Global.isMobileWindow)
  {
    if ($(Global.footerRow).css('position') == 'fixed')
    {
      Global.footerHeight = 0;

      $($(Global.footerRow).find('.iw_component').get().reverse()).each(function ()
      {
        var el = $(this).children('div').children('div');
        Global.footerHeight = Global.footerHeight + el.height();
        $(el).css('top', '-' + Global.footerHeight + 'px');
      });
    }
    else
    {
      var isFooterAbsolute = true;
      var componentHeights = 0;

      $($(Global.footerRow).find('.iw_component').get()).each(function ()
      {
        var el = $(this).children('div').children('div');

        if (el.css('position') != 'absolute')
        {
          isFooterAbsolute = false;
        }
      });

      if (isFooterAbsolute)
      {
        $($(Global.footerRow).find('.iw_component').get()).each(function ()
        {
          var el = $(this).children('div').children('div');
          $(el).css('top', componentHeights + 'px');
          componentHeights = componentHeights + el.height();
        });

        if ($.isFunction($(Global.footerRow).has) && ($(Global.footerRow).has(Global.drawerIdentifier).length > 0))
        {
          $(Global.footerRow).css('position', 'absolute');
          $(Global.footerRow).css('height', Global.footerHeight + 'px');
        }
        else
        {
          Global.SetFooterPosition();
        }
      }

      $(Global.bodyIdentifier).css('padding-bottom', Global.footerHeight + 'px');
    }
  }
}

// This function sets the value of the footer trigger after a text resize.
Global.ResetFooterTrigger = function()
{
  if ($(document).height() > Global.defaultDocumentHeight)
  {
    Global.footerTrigger = Global.footerTrigger + ($(document).height() - Global.defaultDocumentHeight) + Global.drawerTabHeight;
  }
  else
  {
    Global.footerTrigger = Global.footerTrigger - (Global.defaultDocumentHeight - $(document).height()) + Global.drawerTabHeight;
  }

  Global.defaultDocumentHeight = $(document).height();
}

// This function updates styles when pages are viewed on a device utilizing the responsive styles.
Global.SetResponsiveStyles = function ()
{
  $(Global.zipCodeOverlayIdentifier).dialog("option", "position", "center").parents(".ui-dialog:first").css("top", "");
}

// This function swaps divs on the home page when in responsive view.
Global.SwapHomePageDivs = function ()
{
  if (Global.isTabletWindow || Global.isMobileWindow)
  {
    $(Global.rightBodyColumn).each(function ()
    {
      if (!$(this).text().match(/^\s*$/))
      {
        $(this).insertBefore($(this).prev(Global.leftBodyColumn));
      }
    });
  }
  else
  {
    $(Global.leftBodyColumn).each(function ()
    {
      if (!$(this).text().match(/^\s*$/))
      {
        $(this).insertBefore($(this).prev(Global.rightBodyColumn));
      }
    });
  }
}



// This function adjusts the position of the left rail area when a user scrolls through the page.
Global.ScrollLeftRail = function(animate)
{
  if (Global.isMobileWindow || Global.isTabletWindow || Global.isWideMobileWindow)
  {
    $(Global.leftRailArea).css('top', '');
    $(Global.leftRailArea).css('position', '');
  }
  else
  {
    if (!Global.isMobileWindow && !Global.isWideMobileWindow && Global.scrollLeftRail && ($(Global.leftRailArea).length > 0) && !Global.isTablet && ($(Global.leftRailArea + ":animated").length <= 0))
    {
      var scrollTop = $(window).scrollTop();
      var leftRailHeight = $(Global.leftRailArea).height();
      var headerHeight = 0;
      var bodyOffset = 0;
      var footerOffset = 0;
      var footerTrigger = 0;

      if ($(Global.headerRow).length > 0)
      {
        headerHeight = Global.headerHeight;
      }

      if ($(Global.bodyRow).offset().top > 0)
      {
        bodyOffset = $(Global.bodyRow).offset().top - headerHeight;
      }

      if ($(Global.leftRailArea).next('div').attr('id') == Global.bodyArea.replace('#', ''))
      {
        if (($(Global.bannerIdentifier).offset().top + $(Global.bannerIdentifier).height()) > bodyOffset)
        {
          bodyOffset = bodyOffset + $(Global.bannerIdentifier).height();
        }

        $(Global.leftRailArea).css('left', ($(Global.bodyIdentifier).offset().left));
        $(Global.bodyArea).css('float', 'right');
      }

      if ($(Global.footerRow).length > 0)
      {
        footerOffset = $(Global.footerRow).offset().top;
      }

      footerTrigger = footerOffset - headerHeight - leftRailHeight;



      // Handle moving div up when the footer is visible.
      if (scrollTop >= (footerTrigger - leftRailHeight - headerHeight))
      {
        $(Global.leftRailArea).stop(true, false);
        topVal = footerTrigger - leftRailHeight;

        if (animate)
        {
          $(Global.leftRailArea).animate({ 'top': topVal + "px" });
          //$(Global.leftRailArea).animate({ 'top': '', 'bottom': '0px' });
        }
        else
        {
          $(Global.leftRailArea).css('top', topVal + "px");
          //$(Global.leftRailArea).css({ 'top': '', 'bottom': '0px'});
        }

        $(Global.leftRailArea).css('position', 'absolute');
      }
        // Handle keeping the div in one spot during most of the scroll.
      else if (scrollTop > bodyOffset)
      {
        $(Global.leftRailArea).stop(true, false);

        if (animate)
        {
          $(Global.leftRailArea).animate({ 'top': headerHeight, 'bottom': '' });
        }
        else
        {
          $(Global.leftRailArea).css({ 'top': headerHeight, 'bottom': '' });
        }

        $(Global.leftRailArea).css('position', 'fixed');
      }
        // Handle moving div up when at the top of the page.
        //if (scrollTop == 0)
      else
      {
        $(Global.leftRailArea).stop(true, false);

        if (animate)
        {
          $(Global.leftRailArea).animate({ 'top': '', 'bottom': '' });
        }
        else
        {
          $(Global.leftRailArea).css({'top': '', 'bottom': ''});
        }

        $(Global.leftRailArea).css('position', '');
      }
    }
  }
}

// This function shows or hides the back to top arrow when a user scrolls through the page.
Global.ScrollBackToTop = function(animate)
{
  if (($(window).width() <= Global.widthTablet) && ($('html, body' + ":animated").length <= 1))
  {
    $('.top').stop(true, false);

    if (($('html').scrollTop() > ($(window).height() / 2)) || ($('body').scrollTop() > ($(window).height() / 2)))
    {
      if (animate)
      {
        $('.top').fadeIn(500);
      }
      else
      {
        $('.top').show();
      }
    }
    else
    {
      if (animate)
      {
        $('.top').fadeOut(500);
      }
      else
      {
        $('.top').hide();
      }
    }
  }
}





// This function toggles the Top Navigation component to open or close.
Global.ToggleTopNavigation = function()
{
  if (Global.isTopNavigationExpanded)
  {
    Global.CollapseTopNavigation()
  }
  else
  {
    Global.ExpandTopNavigation();
  }
}

// This function expands the Top Navigation component.
Global.ExpandTopNavigation = function(navigationItem)
{
  $(window).off("resize");

  Global.headerHeight = Global.defaultHeaderHeight - 12;

  if ($(navigationItem).children("ul").length > 0)
  {
    $($(navigationItem).children("ul").get()).each(function()
    {
      Global.headerHeight = Global.headerHeight + $(this).height();
    });
  }
  else
  {
    Global.headerHeight = Global.headerHeight - 6;

    $($(navigationItem).children("div").get()).each(function()
    {
      if ($(this).children("ul").length > 0)
      {
        Global.headerHeight = Global.headerHeight + $(this).children("ul").height();
      }
      else
      {
        Global.headerHeight = Global.headerHeight + $(this).height();
      }
    });
  }

  $(Global.headerRow).stop(true, false);
  $(Global.headerRow).css('height', Global.headerHeight);

  if (Global.loadComplete)
  {
    Global.SetContentPadding(true);
    Global.ScrollLeftRail(true);
    Global.ScrollBackToTop(true);
  }
  else
  {
    Global.SetContentPadding(false);
    Global.ScrollLeftRail(false);
    Global.ScrollBackToTop(false);
  }

  Global.BindResize();

  Global.isTopNavigationExpanded = true;
}

// This function collapses the Top Navigation component.
Global.CollapseTopNavigation = function()
{
  if (Global.isTopNavigationExpanded)
  {
    if ($('.MyAccountPrimaryNav').parent().hasClass('selected') == false)
    {
      $(window).off("resize");

      try
      {
        ResponsiveTopNavigation.CloseNav();
      }
      catch (ex)
      {
      }

      Global.headerHeight = Global.defaultHeaderHeight;

      $(Global.headerRow).stop(true, false);
      $(Global.headerRow).css('height', Global.headerHeight);

      if (Global.loadComplete)
      {
        Global.SetContentPadding(true);
        Global.ScrollLeftRail(true);
        Global.ScrollBackToTop(true);
      }
      else
      {
        Global.SetContentPadding(false);
        Global.ScrollLeftRail(false);
        Global.ScrollBackToTop(false);
      }

      Global.BindResize();

      Global.isTopNavigationExpanded = false;
    }
  }
}


// This function toggles the Top Hat section of the Responsive Top Navigation component to open or close.
Global.ToggleTopHat = function () {
    if (Global.isTopHatExpanded) {
        Global.CollapseTopHat()
    }
    else {
        Global.ExpandTopHat();
        ProcessMetrics('OpenExplore');
    }
}

// This function expands the Top Hat section of the Responsive Top Navigation component.
Global.ExpandTopHat = function () {
    if (!Global.isTopHatExpanded) {
        $(Global.tophatArea).show();

        Global.CollapseTopNavigation();

        Global.isTopHatExpanded = true;        
    }

    $('.tophatExplore').addClass('expanded');
}

// This function collapses the Top Hat section of the Responsive Top Navigation component.
Global.CollapseTopHat = function () {
    if (Global.isTopHatExpanded) {
        $(Global.tophatArea).hide();

        Global.isTopHatExpanded = false;        
    }

    $('.tophatExplore').removeClass('expanded');
}


// This function checks if an image is actually part of the page.
Global.IsImageOk = function(img)
{
  if ((!img.complete) || ((typeof img.naturalWidth != "undefined" && img.naturalWidth <= 1) && (img.src.indexOf("data") < 0)))
  {
    return false;
  }

  return true;
}

Global.SetDefaultTopNavigationMenu = function()
{
  if ((typeof liSelectedIndex != "undefined") && (liSelectedIndex != null) && (liSelectedIndex >= 0))
  {
    $('ul#MainMenu > li').eq(liSelectedIndex).click();
  }
  else
  {
    $('div.IconTopNav').addClass('IconTopNavShadow');
  }
  $('.zipEdit').click(function(e) {e.preventDefault();});
}

Global.CollapseQuoteBox = function()
{
  if ($('.quoteDrop').length > 0)
  {
    if ($('.quoteHead').length > 0)
    {
      $('.quoteHead').removeClass('show');
    }
    if ($('.quoteDrawer').length > 0)
    {
      $('.quoteDrawer').removeClass('show');
    }
  }
}

Global.SetIsLocalStorageAvailable = function () {
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        Global.IsLocalStorageAvailable = true;
    } catch (e) {
        Global.IsLocalStorageAvailable = false;
    }
}


// Set initial top padding to prevent the page from pushing down on load.
$(document).ready(function()
{
  Global.SetIsLocalStorageAvailable();
  Global.SetWindowProperties();
  Global.DetectBrowser();

  Global.SetHeaderHeightValues();
  if ($(Global.globalNavigationArea).length <= 0)
  {
    Global.SetContentPadding();
  }
  Global.SetLeftRailScrolling();

  Global.defaultDocumentHeight = $(document).height();

  $('body').animate({ opacity: '1' }, 'fast').css('visibility', 'visible');
});

// Initialize when the page is ready.
$(window).on("load", function()
{

  Global.SetDefaultTopNavigationMenu();

  //Global.ScrollLeftRail();
  Global.ScrollBackToTop();

  Global.SwapHomePageDivs();

  Global.loadComplete = true;
});

// Bind to the scroll event to support Top Navigatio and Left Rail functionality.
$(window).scroll(function ()
{
  if (Global.loadComplete)
  {
    Global.CollapseTopNavigation();
    Global.CollapseQuoteBox();
    Global.CollapseTopHat();

    //Global.ScrollLeftRail();

    clearTimeout($.data(this, "scrollCheck"));
    $.data(this, "scrollCheck", setTimeout(function ()
    {
      Global.ScrollBackToTop(true);
    }, 250));
  }
});




Global.InitializeZipOverlay = function()
{
  if ($.isFunction($(Global.zipCodeOverlayIdentifier).dialog))
  {
    var dialogWindow = $(Global.zipCodeOverlayIdentifier).dialog({
      autoOpen: false, draggable: false, height: 'auto', modal: true, resizable: false, width: '582px;',
      open: function(e)
      {
        e.preventDefault();

        $(".ui-widget-overlay").appendTo("form");
        $(".ui-widget-overlay").addClass("ZipCodeOverlayBackground").css("z-index", "1000");
        $(this).parents(".ui-dialog:first").addClass("ZipCodeOverlay").css("top", "").css("left", "");
        $(this).parents(".ui-dialog:first").find(".ui-dialog-titlebar").addClass("Title");
        $(this).parents(".ui-dialog:first").find(".ui-dialog-titlebar-close").addClass("Close");
        $(this).parents(".ui-dialog:first").find(".ui-dialog-content").addClass("Background").css("height", "").css("min-height", "150px");

        $(Global.zipCodeOverlayDelayIdentifier).css("display", "none");

        if ($(this).data("quoteProduct") != undefined)
        {
          $(Global.zipCodeOverlayQuoteProductIdentifier).val($(this).data("quoteProduct"));
        }

        if ($(this).data("quoteCampaign") != undefined)
        {
          $(Global.zipCodeOverlayQuoteCampaignIdentifier).val($(this).data("quoteCampaign").replace("?fake=", ""));
        }

        if ($(this).data("quoteMobile") != undefined)
        {
          $(Global.zipCodeOverlayQuoteMobileIdentifier).val($(this).data("quoteMobile"));
        }

        if (!navigator.geolocation)
        {
          $(this).children(".GeoLocation").removeClass("GeoLocation").addClass("GeoLocationHidden");
        }

        Global.SetPageState($(this).data("component"));

        $(Global.zipCodeOverlayIdentifier).dialog("option", "position", {my: "center", at: "center", of: window}).parents(".ui-dialog:first").css("top", "");
      }
    });

    $(Global.zipCodeOverlayIdentifier).on('dialogclose', function(event)
    {
      Global.ClearPageState();
    });

    dialogWindow.parent().appendTo("form");
  }
}

Global.FocusZipCode = function(zipBox)
{
  if ($(zipBox).hasClass("Active") != true)
  {
    $(zipBox).addClass("Active");
    $(zipBox).children("input[type=button]").css("display", "inline");
    $(zipBox).children(".ErrorImage").css("display", "none");
    $(zipBox).next().css("display", "inline");
    $(zipBox).children("input[type=text]").focus();
    $(zipBox).children("input[type=text]").val($(zipBox).children("input[type=text]").val());
  }
}

Global.CancelZipEntry = function(cancelLink)
{
  if ($(cancelLink).hasClass("Active") == true)
  {
    $(cancelLink).removeClass("Active");
    $(cancelLink).children("input[type=number]").val(Global.zipCodeOverlayZipCode);
    $(cancelLink).children("input[type=button]").css("display", "none").removeClass("Enabled").attr("disabled", "disabled");
    $(cancelLink).next().css("display", "none");
  }
}

Global.EnterZipText = function(zipInput, e)
{
  if (($(zipInput).val().length == parseInt($(zipInput).attr('maxlength'), 10)) && ($(zipInput).val() != Global.zipCodeOverlayZipCode))
  {
    $(zipInput).next().addClass("Enabled");
    $(zipInput).next().removeAttr("disabled");
    $("#imgError").css("display", "none");
    $(Global.zipCodeOverlaySaveButtonIdentifier).css("display", "block");

    if (e.keyCode == 13)
    {
      $(zipInput).next().click();
    }
  }
  else
  {
    $(zipInput).next().removeClass("Enabled");
    $(zipInput).next().attr("disabled", "disabled");
  }
}
var lt = /</g,
    gt = />/g,
    ap = /'/g,
    ic = /"/g;  
Global.SubmitZipCodeUpdate = function(method)
{
  $(Global.zipCodeProgressOverlay).css("display", "block");
  Global.zipCodeProgressOverlayTimeout = setTimeout(function () { $(Global.zipCodeOverlayDelayIdentifier).css("display", "block"); }, 10000);

  var data = $('form').serializeArray();
  data.push({ name: 'Method', value: method });

  $.ajax({
    type: "POST",
    url: "/anon/handlers/ajaxactivity.ashx",
    dataType: "html",
    data: data,
    success: function(data, textStatus, request)
    {
      Global.ResetAgents();
      if (request.getResponseHeader("location") != null)
      {
          window.location.href = request.getResponseHeader("location").toString().replace(lt, "&lt;").replace(gt, "&gt;").replace(ap, "&#39;").replace(ic, "&#34;");;
      }
      else
      {
        Global.ReloadPage();
      }
    },
    statusCode:
    {
      500: function ()
      {
        if (method == "ZipSave")
        {
          Global.ErrorZipSave();
        }
        else
        {
          Global.ErrorDeviceGeoLocation();
        }
      }
    },
    error: function(error)
    {
      if (method == "ZipSave")
      {
        Global.ErrorZipSave();
      }
      else
      {
        Global.ErrorDeviceGeoLocation();
      }
    }
  });
}

Global.ClearZipCodeLoadingOverlay = function()
{
  clearTimeout(Global.zipCodeProgressOverlayTimeout);
  $(Global.zipCodeProgressOverlay).css("display", "none");
  $(Global.zipCodeOverlayDelayIdentifier).css("display", "none");
}

Global.GetDeviceGeoLocation = function()
{
  if (navigator.geolocation != null)
  {
    $(Global.zipCodeProgressOverlay).css("display", "block");
    navigator.geolocation.getCurrentPosition(Global.PostDeviceGeoLocation, Global.ErrorDeviceGeoLocation, { timeout: 7500 });
  }
  else
  {
    Global.ErrorDeviceGeoLocation();
  }
}

Global.PostDeviceGeoLocation = function(position)
{
  if ((position != undefined) && (position.coords.latitude != undefined) && (position.coords.longitude != undefined))
  {
    $(Global.zipCodeOverlayLatitudeIdentifier).val(position.coords.latitude);
    $(Global.zipCodeOverlayLongitudeIdentifier).val(position.coords.longitude);

    $(Global.zipCodeOverlayGeoLocationButtonIdentifier).click();
  }
  else
  {
    Global.ErrorDeviceGeoLocation();
  }
}

Global.ErrorZipSave = function ()
{
  Global.ClearZipCodeLoadingOverlay();
  $(Global.zipCodeOverlaySaveErrorIdentifier).css("display", "block");
  $(Global.zipCodeOverlayGeoLocationErrorIdentifier).css("display", "none");
  $("#imgError").css("display", "block");
  $(Global.zipCodeOverlaySaveButtonIdentifier).css("display", "none");
  $(Global.zipCodeOverlayZipBoxIdentifier).addClass("Error");
}

Global.ErrorDeviceGeoLocation = function()
{
  Global.ClearZipCodeLoadingOverlay();
  $(Global.zipCodeOverlaySaveErrorIdentifier).css("display", "none");
  $(Global.zipCodeOverlayGeoLocationErrorIdentifier).css("display", "block");
  $("#GeoLocation").css("display", "none");
}

Global.ReloadPage = function()
{
    var query_arg_regex, url;
    if (document.forms[0].action.indexOf('AgentNumber=') > 0) {
        query_arg_regex = new RegExp('AgentNumber=([0-9]*)');
        url = document.forms[0].action.replace(query_arg_regex, '');
        location.href = url;
    }
    else {
        location.reload();
    }
    
}

Global.SetPageState = function(component)
{
  document.cookie = Global.pageStateCookie + '=' + component + '; path=/';
}

Global.RestorePageState = function()
{
  var cookie = document.cookie.match(Global.pageStateCookie + '=([^;]*)');

  if ((cookie != undefined) && (cookie != null) && (cookie[1] != null))
  {
    return cookie[1];
  }
  else
  {
    return null;
  }
}

Global.ClearPageState = function()
{
  document.cookie = Global.pageStateCookie + '=;expires=0; path=/';
}

Global.BackToTop = function()
{
  $('html, body').animate({ scrollTop: 0 }, 'slow');
  setTimeout(Global.ScrollBackToTop(true), 1500);
  return false;
}

Global.GetAgentReview = function (agentNumber)
{
  var agentReviewRequested = false;
  Global.agentReviewsRequested.forEach(function (item, index, array)
  {
    if (item === agentNumber)
    {
      agentReviewRequested = true;
    }
  });

  if (!agentReviewRequested)
  {
    Global.agentReviewsRequested.push(agentNumber);

    $.ajax({
      type: "GET",
      url: "https://allstate.reviewability.com/reviews/as-" + agentNumber + ".0.json",
      contentType: "text/plain",
      dataType: "json",
      crossDomain: true,
      timeout: 5000,
      headers: null
    })
    .done(function (data)
    {
      Global.CreateReviewDiv(agentNumber, data, false);
    })
    .fail(function (data)
    {
      Global.CreateReviewDiv(agentNumber, null, true);
    })
    .always(function (data)
    {
      $.CallbackEvents("GetAgentReview-" + agentNumber).publish();
    });
  }
}

Global.CreateReviewDiv = function (agentNumber, reviewData, createDefaultDiv)
{
  if ((reviewData === undefined) || (createDefaultDiv === true))
  {
    reviewData = { total: 0, average: 0 };
  }

  reviewDiv = "<div class='AgentReviews reviews-" + agentNumber + "'>";

  for (var b = "", c = Math.floor(reviewData.average), d = 0; c > d; d += 1)
  {
  	reviewDiv += "<span class='star full'>&nbsp;</span>";
  }

  1 == Math.ceil(reviewData.average - Math.floor(reviewData.average)) && (reviewDiv += "<span class='star half'>&nbsp;</span>");

  for (var e = 5 - Math.ceil(reviewData.average), f = 0; e > f; f += 1)
  {
  	reviewDiv += "<span class='star empty'>&nbsp;</span>";
  }

  reviewDiv += "<span class='count'>";
  reviewDiv += reviewData.total;
  reviewDiv += " ";
  reviewDiv += Global.agentReviewLinkText;

  if (reviewData.total != 1) {
      reviewDiv += "s";
  }

  reviewDiv += "</span>";
  reviewDiv += "</div>";

  $('body').append(reviewDiv);

  AgentsNearYou.GetFiveStars(agentNumber, reviewDiv);
  AgentFlyout.GetFiveStars(agentNumber, reviewDiv);

  //if (typeof bsAgentsNearYou != 'undefined') {
  //    bsAgentsNearYou.GetFiveStars(agentNumber, reviewDiv)
  //}
}

Global.ParseAgents = function () {
    var myAgentsFromGlobal = Global.myAgents;
    if (myAgentsFromGlobal !== '') {
        try {
            var myAgents = JSON.parse(myAgentsFromGlobal);
            if ((myAgents.Agents !== null) && (myAgents.Agents != "null")) {
                var myAgentsFromAJAXCount = myAgents.Agents.length;
            }
        } catch (e) {
            Global.ResetAgents();

            if ($('.AgentsNearYou').length == 0) {
                var myHTML = "<li><div class='agentsFindMessage'>No Agents Found.</div></li>";
                $('.AgentsNearYou .anyAgentListing').append(myHTML);
            }
            if ($('.AgentFlyout').length == 0) {
                var myHTML = "<li><div class='agentsFindMessage'>No Agents Found.</div></li>";
                $('.AgentFlyout .afoAgentListing').append(myHTML);
            }
        }
    }
}


Global.GetAgentsFromAAS = function () {
    //JS function that calls the Agent List Handler
    $.ajax({
        url: "/anon/handlers/ajaxactivity.ashx?Method=JsonAgentList", success: function (result) {

            if (!Date.now) {
                Date.now = function () { return new Date().getTime(); }
            }
            var myNumDays = 2;
            var myExpiresTimestamp = Date.now() + (myNumDays * 24 * 3600 * 1000);

            if (Global.IsLocalStorageAvailable === true) {
                localStorage.setItem("LocalAgentsExpires", myExpiresTimestamp);
                localStorage.setItem("LocalAgents", result);
                localStorage.setItem("LocalAgentsZip", Global.userZipCode);
            }

            Global.myAgents = result;

            if (Global.myAgents !== null) {
                Global.ParseAgents();
            }
        }, error: function (request, status, error) {
            Global.ResetAgents();

            if ($('.AgentsNearYou').length == 0) {
                var myHTML = "<li><div class='agentsFindMessage'>No Agents Found.</div></li>";
                $('.AgentsNearYou .anyAgentListing').append(myHTML);
            }
            if ($('.AgentFlyout').length == 0) {
                var myHTML = "<li><div class='agentsFindMessage'>No Agents Found.</div></li>";
                $('.AgentFlyout .afoAgentListing').append(myHTML);
            }
        }
    });
}

Global.GetAgents = function ()
{
  Global.myAgents = '';
  if (Global.IsLocalStorageAvailable === true)
  {
    var myLocalAgents = localStorage.getItem("LocalAgents");
    var myLocalAgentsExpires = localStorage.getItem("LocalAgentsExpires");
    var myLocalAgentsZip = localStorage.getItem("LocalAgentsZip");

    if (myLocalAgentsExpires !== null)
    {
      if (Date.now() < myLocalAgentsExpires)
      {
        if (myLocalAgentsZip !== null)
        {
          if (Global.userZipCode == myLocalAgentsZip)
          {
            if (myLocalAgents !== null)
            {
              //Return from local storage
              Global.myAgents = myLocalAgents;

              if ((Global.myAgents !== null) && (Global.myAgents !== 'null') && (Global.myAgents !== '{"Agents":null,"AgentListType":2}'))
              {
                Global.ParseAgents();
              }
              else
              {
                //Previous call failed
                Global.GetAgentsFromAAS();
              }
            }
            else
            {
              //No local storage call service
              Global.GetAgentsFromAAS();
            }
          }
          else
          {
            //Agent zip doesn't match to current user zip
            Global.GetAgentsFromAAS();
          }
        }
        else
        {
          //No Agent zip code
          Global.GetAgentsFromAAS();
        }
      }
      else
      {
        //Expired call service
        Global.GetAgentsFromAAS();
      }
    }
    else
    {
      //No expiration call service
      Global.GetAgentsFromAAS();
    }
  } else
  {
    //Local Storage not supported
    Global.GetAgentsFromAAS();
  }
}

Global.ResetAgents = function ()
{
  if (Global.IsLocalStorageAvailable === true)
  {
    localStorage.removeItem("LocalAgents");
    localStorage.removeItem("LocalAgentsExpires");
    localStorage.removeItem("LocalAgentsZip");
  }
}
Global.htmlEncode= function(str) {
    return String(str).replace(/[^\w. ]/gi, function (c) {
        return '&#' + c.charCodeAt(0) + ';';
    });
}
Global.GetPaymentInformation = function()
{
  $.ajax({
    type: "GET",
    url: "/anon/handlers/ajaxactivity.ashx?Method=PaymentInformation",
    dataType: "json",
    success: function(data)
    {
      $("#paymentResults").html(JSON.stringify(data));
    },
    statusCode:
    {
    },
    error: function(error)
    {
    }
  });
}

/***** End Global Scripts *****/

/*!
//# sourceMappingURL=PageLayouts.min.js.map
*/
